import { SearchStepper } from "../search-stepper";
import { StepValidationState } from "projects/reg-hub-client/src/interfaces/step";
import { InternationalBusinessSearchCriteriaComponent } from "projects/reg-hub-client/src/app/orders/international-business-search-criteria/international-business-search-criteria.component";
import { BusinessSearchReviewComponent } from "projects/reg-hub-client/src/app/orders/business-search-review/business-search-review.component";

export class _IBusinessSearchStepper extends SearchStepper {
    constructor() {
        super()

        this.steps = [
            { title: "Search Criteria", content: InternationalBusinessSearchCriteriaComponent, validationState: StepValidationState.DefaultState },
            { title: "Review", content: BusinessSearchReviewComponent, validationState: StepValidationState.DefaultState }
        ]
    }
}
